/* eslint-disable @typescript-eslint/no-explicit-any */
import './OverlapAvatar.scss'

const OverlapAvatar = ({
  avatarList = [1, 2, 3]
}: any) => {

  return <ul className="overlap-avatar">
    {
      avatarList.map((_avatar: any, index: number) => {
        return <li><img src={`https://ui-avatars.com/api/?name=${index}`} /></li>
      })
    }
  </ul>
}

export default OverlapAvatar